import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { UrlWithStringQuery } from 'url';
import { environment } from '../../../environments/environment';
import { EmailModule } from '../modelo/hoja/email';
import { HojaModule } from '../modelo/hoja/hoja.module';

@Injectable({
  providedIn: 'root'
})
export class ProducionService {

  constructor(private http: HttpClient) { }

  listarProductos(id:string){
    return this.http.get(environment.apiUrlMaxipan+"producto.php?local="+id); 
  }

  obtenerDias(){
    console.log(environment.apiUrlMaxipan+"locales.php?dias=1");
    return this.http.get(environment.apiUrlMaxipan+"locales.php?dias=1"); 
  }


  listarProduccionPorLocal(id:string,id_pais:string){
    console.log(environment.apiUrlMaxipan+"locales.php?id="+id);
    return this.http.get(environment.apiUrlMaxipan+"locales.php?id="+id+"&id_pais="+id_pais); 
  }

    enviarEmail(lista:EmailModule[],local){
    console.log(JSON.stringify(lista));
    return this.http.post(environment.apiUrlMaxipan+"send.php?local="+local,JSON.stringify(lista)); 
  }

  listarProduccionPorLocalxPeriodo(local:string,periodo:string,id_pais){

    return this.http.get(environment.apiUrlMaxipan+"locales.php?consultar="+ periodo+ "&local1="+local+ "&id_pais="+id_pais); 
  }

  listarPeriodoLocal(id_pais){
    return this.http.get(environment.apiUrlMaxipan+"locales.php?periodo=22&id_pais="+id_pais);  
  }


  listarPeriodoLocalTodos(id_pais){
    return this.http.get(environment.apiUrlMaxipan+"locales.php?periodot=22"+"&id_pais="+id_pais);  
  }

  listarProduccionPorLocalParametro(id:string,parametro:string,id_pais:string){
  
    return this.http.get(environment.apiUrlMaxipan+"locales.php?id1="+id+"&parametro="+parametro+"&id_pais="+id_pais); 
  }
  listarProduccion(id:string,fecha:string,id_pais:string){
    console.log(environment.apiUrlMaxipan+"produccion.php?id_local="+id+"&fecha="+fecha);
    return this.http.get(environment.apiUrlMaxipan+"produccion.php?id_local="+id+"&fecha="+fecha+"&id_pais="+id_pais); 
  }

  listarProduccionTodos(id:string,fecha:string,idPais){
    console.log(environment.apiUrlMaxipan+"produccion.php?id_local="+id+"&fecha="+fecha);
    return this.http.get(environment.apiUrlMaxipan+"produccion.php?id_local="+id+"&fecha="+fecha+"&id_pais="+idPais); 
  }

  listarVersionxLocal(id:string, idPais:string){
    console.log(environment.apiUrlMaxipan+"produccion.php?idDL="+id);
    return this.http.get(environment.apiUrlMaxipan+"produccion.php?idDL="+id+"&id_pais="+idPais); 
  }


  eliminar(id:string,idPais:string,version1:string){
    console.log(environment.apiUrlMaxipan+"produccion.php?idD="+id);
    return this.http.get(environment.apiUrlMaxipan+"produccion.php?idD="+id+"&id_pais="+idPais+"&version="+version1); 
  }


  guardarLocales(hojas:HojaModule[],parametro:string){
    return this.http.post(environment.apiUrlMaxipan+"locales.php?parametro="+parametro,JSON.stringify(hojas)); 
  }

  guardarProduccion(hojas:HojaModule[]){
    return this.http.post(environment.apiUrlMaxipan+"produccion.php",JSON.stringify(hojas)); 
  }


  actualizarProduccionLocales(hojas:HojaModule[]){
    return this.http.post(environment.apiUrlMaxipan+"locales_update.php",JSON.stringify(hojas)); 
  }
}
